module.exports = __webpack_public_path__ + "static/media/Arrow.498c3cb3.svg";